import { render } from "./GaleriaCategoria.vue?vue&type=template&id=065eaa12"
import script from "./GaleriaCategoria.vue?vue&type=script&lang=js"
export * from "./GaleriaCategoria.vue?vue&type=script&lang=js"

import "./GaleriaCategoria.vue?vue&type=style&index=0&id=065eaa12&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__